module.exports = __webpack_public_path__ + "static/img/contest_img_gen.f99f7f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contests/contest_img_gen.png
// module id = 7efU
// module chunks = 12